// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__3HPHN","alert":"SettungsInbox_alert__3p71g"};